import { render, staticRenderFns } from "./DepositStep.vue?vue&type=template&id=b5a18b36"
import script from "./DepositStep.vue?vue&type=script&lang=js"
export * from "./DepositStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports